import { Component, Element, Event, EventEmitter, h, Host, Prop } from '@stencil/core'

import Helpers from '../../../utils/helpers'

/**
 * ## Design System
 *
 * Para a documentação completa de design, incluindo diretrizes de uso, acessibilidade e exemplos visuais, consulte o [Design System do GovBR](https://www.gov.br/ds/components/menu?tab=designer).
 *
 * @slot icon - Slot para ícone personalizado da rede social.
 */
@Component({
  tag: 'br-menu-social',
  styleUrl: 'menu-social.scss',
  shadow: true,
})
export class MenuSocial {
  /**
   * Referência ao elemento host do componente.
   * Utilize esta propriedade para acessar e manipular o elemento do DOM associado ao componente.
   */
  @Element() el: HTMLBrMenuSocialElement

  /**
   * Identificador único.
   * Caso não seja fornecido, um ID gerado automaticamente será usado.
   */
  @Prop({ reflect: true }) readonly customId: string = Helpers.generateUniqueId()

  /**
   * URL do link
   */
  @Prop({ reflect: true }) url!: string

  /**
   * Rótulo para acessibilidade
   */
  @Prop({ reflect: true }) ariaLabel!: string

  /**
   * Ícone da rede social
   * */
  @Prop({ reflect: true }) readonly icon: string

  /**
   * Evento emitido quando o link de rede social é clicado
   */
  @Event() brSocialClick: EventEmitter<void>

  private handleClick = () => {
    this.brSocialClick.emit()
  }

  render() {
    return (
      <Host>
        <br-button
          role="link"
          id={this.customId}
          emphasis="tertiary"
          shape="circle"
          aria-label={this.ariaLabel}
          onClick={this.handleClick}
        >
          <a href={this.url} tabindex="-1">
            <slot name="icon">
              <br-icon icon-name={`fa-brands:${this.icon}`} aria-hidden="true"></br-icon>
            </slot>
          </a>
        </br-button>
      </Host>
    )
  }
}
